module.exports = __webpack_public_path__ + "static/img/荣誉_06@2x.5e268da1.png";